import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  title: string;
  cover: string;
  author: string;
  status: string;
  category: string;
  rating: number;
  views: number;
  tags: string[];
  isHot?: boolean;
  isNew?: boolean;
  variant?: 'default' | 'featured';
}

export default function ComicCard({ id, title, cover, author, status, category, rating, views, tags, isHot, isNew, variant = 'default' }: ComicCardProps) {
  const formattedViews = views >= 10000 ? `${(views / 10000).toFixed(0)}万` : views.toString();

  if (variant === 'featured') {
    return (
      <Link to={`/article/${id}`} className="group block bg-background-100 rounded-2xl overflow-hidden transition-colors hover:bg-background-200/70 cursor-pointer" data-product-shop="">
        <div className="relative aspect-[3/4] overflow-hidden">
          <img src={cover} alt={title} title={`${title} - 叮当漫画网`} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" loading="lazy" />
          <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 via-transparent to-transparent"></div>
          <div className="absolute bottom-0 left-0 right-0 p-5">
            <h3 className="text-foreground-100 text-lg font-heading font-bold">{title}</h3>
            <p className="text-foreground-400 text-sm mt-1">{author} · {category}</p>
          </div>
          {isHot && (
            <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-background-50 dark:text-foreground-950 text-xs font-medium rounded-full whitespace-nowrap">热门</span>
          )}
          {isNew && (
            <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500 text-background-50 dark:text-foreground-950 text-xs font-medium rounded-full whitespace-nowrap">新作</span>
          )}
        </div>
        <div className="p-4">
          <div className="flex items-center gap-2 flex-wrap">
            {tags.slice(0, 3).map((tag) => (
              <span key={tag} className="px-2 py-0.5 bg-background-200/50 text-foreground-500 text-xs rounded-md whitespace-nowrap">{tag}</span>
            ))}
          </div>
          <div className="flex items-center justify-between mt-3">
            <span className="flex items-center gap-1 text-accent-500 text-sm">
              <i className="ri-star-fill text-xs"></i>
              {rating}
            </span>
            <span className="text-foreground-600 text-xs">{formattedViews} 阅读</span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link to={`/article/${id}`} className="group block bg-background-100 rounded-xl overflow-hidden transition-colors hover:bg-background-200/70 cursor-pointer" data-product-shop="">
      <div className="relative aspect-[3/4] overflow-hidden">
        <img src={cover} alt={title} title={`${title} - 叮当漫画网`} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" loading="lazy" />
        <div className="absolute top-0 left-0 right-0 p-3 flex items-center justify-between">
          {(isHot || isNew) && (
            <span className={`px-2 py-0.5 text-background-50 dark:text-foreground-950 text-xs font-medium rounded-full whitespace-nowrap ${isHot ? 'bg-primary-500' : 'bg-accent-500'}`}>
              {isHot ? '热门' : '新作'}
            </span>
          )}
          <span className="ml-auto px-2 py-0.5 bg-background-50/70 backdrop-blur-sm text-foreground-700 text-xs rounded-full whitespace-nowrap">{status}</span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-foreground-100 text-sm font-bold truncate">{title}</h3>
        <div className="flex items-center gap-2 mt-1.5">
          <span className="text-foreground-500 text-xs">{author}</span>
          <span className="text-foreground-600 text-xs">·</span>
          <span className="text-foreground-500 text-xs">{category}</span>
        </div>
        <div className="flex items-center justify-between mt-2">
          <span className="flex items-center gap-1 text-accent-500 text-xs">
            <i className="ri-star-fill text-[10px]"></i>
            {rating}
          </span>
          <span className="text-foreground-600 text-[10px]">{formattedViews}</span>
        </div>
      </div>
    </Link>
  );
}